/* ==========================================================================
   Helpers used only by the mock/* service implementations.

   Nothing here is imported by real (non-mock) code paths. Once a service
   function's mock branch is deleted in favour of apiClient, its imports
   from this file go with it.
   ========================================================================== */

import { config } from "../../config";

/** Simulated network latency so pending/loading UI states are actually
 *  visible during a demo instead of resolving instantly. */
export function delay(ms = 700): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

let refCounter = 1000;

/** Mock transaction/payment references. Real references will come from the
 *  backend/payment provider — this only needs to look plausible and be
 *  unique within a demo session. */
export function genReference(prefix: string): string {
  refCounter += 1;
  const stamp = Date.now().toString(36).toUpperCase().slice(-5);
  return `${prefix}-${stamp}${refCounter}`;
}

/** QA hook: when true (see config.forceMockFailure), mock services that
 *  simulate an external call (funding, vending, bill payment) resolve to
 *  their failure branch instead of success, so the failed-state UI can be
 *  reviewed on demand via `?mockFail=1`. */
export function shouldSimulateFailure(): boolean {
  return config.forceMockFailure;
}
